<template>
    <BaseAd>
        <template #title>
            {{ $t('configuratorSpecialDeals.dedicatedAdTitle') }}
        </template>

        <!-- eslint-disable vue/no-v-html -->
        <span
            v-html="
                $t('configuratorSpecialDeals.dedicatedAdDescription', {
                    hrefDedicated: '/dedicated-server',
                    hrefContact: '/contact',
                })
            "
        ></span>
    </BaseAd>
    <!-- eslint-enable vue/no-v-html -->
</template>
